import { render, staticRenderFns } from "./ProfileMiCredito.vue?vue&type=template&id=2b7387b8&"
import script from "./ProfileMiCredito.vue?vue&type=script&lang=js&"
export * from "./ProfileMiCredito.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports